import * as React from "react";

const SpecializeInSEMIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="57"
        height="57"
        fill="none"
        viewBox="0 0 57 57"
    >
        <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
        <g clipPath="url(#clip0_2952_6925)">
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M41.23 45c-.997 0-1.9-.398-2.52-1.126L29.657 33.22c-.319-.375.22-.855.554-.538 1.477-1.188 2.158-2.052 2.449-2.497-.27-.336.196-.838.56-.529l10.653 9.056c2.366 2.01.797 6.286-2.642 6.286"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M23.643 35.288C17.209 35.288 12 30.078 12 23.645s5.21-11.643 11.643-11.643 11.643 5.209 11.643 11.643-5.209 11.643-11.643 11.643"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M23.641 13.352c-9.148 0-13.745 11.104-7.278 17.57 6.469 6.468 17.57 1.868 17.57-7.278a10.29 10.29 0 0 0-10.292-10.292"
                clipRule="evenodd"
            ></path>
            <path
                fill="#EF4F80"
                fillOpacity="0.24"
                d="M33.684 23.645c0-5.55-4.493-10.043-10.043-10.043-8.925 0-13.41 10.834-7.1 17.143h-.001c6.311 6.31 17.144 1.822 17.144-7.1m.5 0c0 9.367-11.371 14.08-17.998 7.454-6.623-6.624-1.916-17.997 7.455-17.997a10.54 10.54 0 0 1 10.543 10.543"
            ></path>
            <path
                fill="#EF4F80"
                fillRule="evenodd"
                d="M23.644 32.587c-4.93 0-8.94-4.011-8.94-8.942 0-.509.773-.509.773 0 0 4.504 3.664 8.168 8.168 8.168.509 0 .508.774 0 .774M32.198 24.031a.387.387 0 0 1-.387-.386c0-4.504-3.664-8.168-8.167-8.168-.51 0-.51-.774 0-.774 4.93 0 8.94 4.011 8.94 8.941a.386.386 0 0 1-.386.387M24.354 26.161H22.21a.387.387 0 0 1-.387-.386v-4.26c0-.213.173-.386.387-.386h2.143c.51 0 .509.773 0 .773h-1.756v3.486h1.756c.509 0 .51.773 0 .773"
                clipRule="evenodd"
            ></path>
            <path
                fill="#EF4F80"
                fillRule="evenodd"
                d="M24.114 24.031H22.21c-.51 0-.51-.773 0-.773h1.904c.51 0 .51.773 0 .773M29.475 26.146a.387.387 0 0 1-.387-.386v-3.185c-1.156 1.35-.924 1.349-2.08 0v3.185c0 .509-.773.509-.773 0v-4.23c0-.359.447-.523.68-.252l1.133 1.322 1.134-1.322a.387.387 0 0 1 .68.252v4.23a.387.387 0 0 1-.387.386M18.877 26.161c-.905 0-1.699-.948-1.119-1.272.514-.286.476.499 1.12.499a.68.68 0 0 0 .677-.678c0-1.182-2.13-.184-2.13-2.13 0-1.61 2.248-2.004 2.81-.51.18.476-.544.748-.723.272-.262-.697-1.313-.514-1.313.239 0 1.182 2.13.184 2.13 2.129 0 .8-.652 1.451-1.452 1.451"
                clipRule="evenodd"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_2952_6925">
                <path fill="#fff" d="M12 12h33v33H12z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default SpecializeInSEMIcon;
